import { ApiClient } from "@/shared/services/api-client";
import { GetUsersGetRequestModel, GetUsersGetResponseModel } from "@/features/user/services/get-users-model";
import { MoneyLinkError, MoneyLinkException, ErrorLevel } from "@/shared/utils/custom-exception";

export class GetUsersApi {
  /**
   * 利用者情報取得API
   */
  public getUsers = async (
    param: GetUsersGetRequestModel
  ): Promise<GetUsersGetResponseModel> => {
    const path = `/api/users`;
    const res = await ApiClient.instance.get<GetUsersGetResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    if (res.body !== undefined) {
      if ( res.body.is_kcloud_auth === undefined
        || res.body.is_kcloud_auth === null
        || res.body.sori_id === undefined
        || res.body.sori_id === null
      ) {
        throw new MoneyLinkException({
          error: new MoneyLinkError({
            level: ErrorLevel.Warn,
            code: 500,
            reason: "unexpected_error",
            messageTitle: undefined,
            messageBody:
              "予期せぬエラーが発生しました。\n時間をおいて再度お試しください。",
          }),
        });
      }
      const ch = new BroadcastChannel('app-events');
      ch.postMessage({
        soriId: res.body.sori_id,
        syncJump: res.body.is_kcloud_auth
      });
      ch.close();
    }

    return res.body;
  };
}
